var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import compact from "lodash/compact";
import { releaseRentDeposit } from "../../redux/rentDeposit/rentDeposit.actions";
import { EExtraIbanSelectValues } from "../../types/contact.types";
import { EContractMemberTypes, EContractType, } from "../../types/contract.types";
import { EPropertyMemberTypes } from "../../types/property.types";
import { ERentDepositProvider, } from "../../types/rentDeposit.types";
import { EField } from "./schema.releaseRentDeposit.types";
export var isPerformingSubmitActionSelector = function () { return function (state) {
    return !!state.rentDeposit.isReleasingRentDeposit;
}; };
export var performingSubmitActionResultSelector = function () { return function (state) {
    return state.rentDeposit.releasedRentDepositId;
}; };
export var performingSubmitActionErrorSelector = function () { return function (state) {
    return state.rentDeposit.releaseRentDepositError;
}; };
export var submitActionCreator = function (rentDeposit, rentDepositId, relatedContract, property) {
    return function (formData) {
        var _a;
        var signers = __spreadArray([], (formData[EField.Signers] || []), true);
        var signAsBroker = formData[EField.SignAsBroker] || [];
        if (signAsBroker.length > 0) {
            signers.push(+signAsBroker[0]);
        }
        var mappedSigners = compact(signers.map(function (accountId) {
            var _a;
            var contractMember = relatedContract.members.find(function (member) { return member.account.id === accountId; });
            var propertyMember = property.members.find(function (member) { return member.account.id === accountId; });
            if (!contractMember && !propertyMember) {
                return undefined;
            }
            var roles = [EContractMemberTypes.Signer];
            if ((contractMember === null || contractMember === void 0 ? void 0 : contractMember.roles.includes(EContractMemberTypes.Tenant)) ||
                (propertyMember === null || propertyMember === void 0 ? void 0 : propertyMember.roles.includes(EPropertyMemberTypes.Tenant))) {
                roles.push(EContractMemberTypes.Tenant);
            }
            if ((contractMember === null || contractMember === void 0 ? void 0 : contractMember.roles.includes(EContractMemberTypes.Parent)) ||
                (propertyMember === null || propertyMember === void 0 ? void 0 : propertyMember.roles.includes(EPropertyMemberTypes.Parent))) {
                roles.push(EContractMemberTypes.Parent);
            }
            if ((contractMember === null || contractMember === void 0 ? void 0 : contractMember.roles.includes(EContractMemberTypes.Owner)) ||
                (propertyMember === null || propertyMember === void 0 ? void 0 : propertyMember.roles.includes(EPropertyMemberTypes.Owner))) {
                roles.push(EContractMemberTypes.Owner);
            }
            if ((contractMember === null || contractMember === void 0 ? void 0 : contractMember.roles.includes(EContractMemberTypes.Broker)) ||
                (propertyMember === null || propertyMember === void 0 ? void 0 : propertyMember.roles.includes(EPropertyMemberTypes.Broker))) {
                roles.push(EContractMemberTypes.Broker);
            }
            if ((_a = formData[EField.TenantReceiver]) === null || _a === void 0 ? void 0 : _a.includes(accountId)) {
                roles.push(EContractMemberTypes.Receiver);
            }
            return {
                roles: roles,
                accountId: accountId,
            };
        }));
        var data = {
            rentDepositId: rentDepositId,
            propertyId: property.id,
            relatedContractId: relatedContract.id,
            contractType: EContractType.RentDepositRelease,
            ownerAmount: formData[EField.OwnerAmount],
            ownerBankAccountId: formData[EField.OwnerBankAccountId],
            tenantAmount: formData[EField.TenantAmount],
            tenantBankAccountId: formData[EField.TenantBankAccountId] === EExtraIbanSelectValues.Unknown
                ? null
                : formData[EField.TenantBankAccountId],
            brokerAmount: formData[EField.BrokerAmount],
            brokerBankAccountId: formData[EField.BrokerBankAccountId],
            startDate: new Date(),
            members: mappedSigners,
            provider: rentDeposit.provider || ERentDepositProvider.MangoPay,
            isJudicialRelease: formData[EField.JudicialRelease],
            judicialReleaseDocumentId: formData[EField.VerdictPdf],
        };
        if (((_a = formData[EField.IdentityDocuments]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var rentDepositValidations = formData[EField.IdentityDocuments].map(function (item) { return (__assign(__assign({}, item), { dateOfExpiry: formData[EField.DateOfExpiry] })); });
            data["rentDepositValidations"] = rentDepositValidations;
        }
        return releaseRentDeposit.actions.start(data);
    };
};
